<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
defineProps({
  loading: { type: Boolean, default: false },
  label: { type: String, default: 'Ver mais' },
});

const emit = defineEmits(['click']);
</script>

<template>
  <button
    type="button"
    class="inline-flex items-center gap-2 rounded-full border border-lais-border px-4 py-2 text-[13px] font-semibold text-lais-text"
    :disabled="loading"
    :aria-busy="loading ? 'true' : undefined"
    @click="emit('click')"
  >
    <span
      :class="
        loading
          ? 'i-lucide-loader-circle animate-spin'
          : 'i-lucide-chevron-down'
      "
      class="size-4"
      aria-hidden="true"
    />
    {{ label }}
  </button>
</template>
